import { ICard } from '../../model/models/payment-methods';
import { IValidateCardResponseEntity } from '../../model/api/payment-accounts';
import { IPaymentProvider } from './payment.interface';
import { IOrder } from '../../model/models/order/order-interface';
import { IValidateOrderResponse } from '../../model/models/order/validate-order-response.interface';

export class PaymentProviderFiserv implements IPaymentProvider {
  getSignatureFields(model) {
    return {
      bill_to_forename: model.firstName,
      bill_to_surname: model.lastName,
      bill_to_address_country: model.country,
      baddr1: model.street,
      bcity: model.city,
      bstate: model.stateProvince,
      bzip: model.postCode,
      payment_token_title: model.alias,
      unsigned_field_names: 'card_type,card_number,card_expiry_date,card_cvn,merchant_secure_data1'
    };
  }

  createRequest(card: ICard, response: IValidateCardResponseEntity) {
    const entity = { ...response.sourceSignature.signatureFields };
    for (const key in entity) {
      let value = entity[key];
      if (!value || value === 'null')
        value = '';
      entity[key] = value;
    }

    entity.cardnumber = card.accountNumber;
    let month = card.expiryMonth.toString();
    if (month.length === 1) {
      month = `0${month}`;
    }
    entity.expyear =  card.expiryYear;
    entity.expmonth =  month;
    entity.cvm = card.cvn;

    return entity;
  }

  handleResponse(provider, response) {
    return true;
  }

  async forwardResponse(provider, baseUrl, card: ICard, response): Promise<any> {
    return this.checkAddedCardPromise(provider, baseUrl, card, 10);
  }

  /**
   * @description Check if the card has been added
   */
  checkAddedCardPromise(provider, baseUrl, card: ICard, tries: number = 1): Promise<Partial<ICard>> {
    return new Promise(async (resolve, reject) => {
      await this.checkAddedCardRequest(provider, baseUrl, card, tries, resolve, reject, );
    })
  }

  private async checkAddedCardRequest(provider, baseUrl, card, tries, resolve, reject) {
    try {
      let res = await provider.httpProvider.get((`${ baseUrl }account/card/verify-fiserv-card-addition`));
      if (res && res.toString().length > 0 && res.accountId) {
        return resolve(res);
      }
      else if (tries > 0) {
        setTimeout(async () => {
          try {
            this.checkAddedCardRequest(provider, baseUrl, card, (tries - 1), resolve, reject)
          } catch(ex){
            reject(ex);
          }
        }, 500);
      }
      else {
        reject(false);
      }
    } catch(ex) {
      reject(ex)
    }
   
  }

  async clientSideAuthorization() {
    throw new Error('Client-side authorization not available for fiserv');
  }
}



// WEBPACK FOOTER //
// ./src/providers/payment/payment.fiserv.ts